import { ConfirmationModal, useModal } from '@procurify/ui'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { SpendingCardUseCaseErrors } from '@webapp/modules/spending-cards/business-logic/use-cases/SpendingCardUseCaseErrors'
import { useMutateActivatePhysicalCard } from '@webapp/modules/spending-cards/features/activate-physical-card/models/useMutateActivatePhysicalCard'
import messages from './messages'

export const useActivatePhysicalCardButtonPresenter = () => {
  const modal = useModal()
  const intl = useProcurifyIntl()

  const { activatePhysicalCard } = useMutateActivatePhysicalCard()

  const onActivateCardSubmit = async ({
    done,
    externalId,
    onCardActivated,
  }: {
    done: () => void
    externalId: string
    onCardActivated: () => void
  }) => {
    try {
      await activatePhysicalCard({ externalId })
      modal.hideModal()

      onCardActivated()

      toast.success({
        title: intl.formatMessage(messages.successToastMessage),
      })
    } catch (error) {
      done()

      if (
        error instanceof SpendingCardUseCaseErrors &&
        error.name === 'ERROR_ACTIVATING_PHYSICAL_CARD'
      ) {
        toast.error({
          title: intl.formatMessage(messages.errorToastTitle),
          children: error.message,
        })
      } else {
        toast.error({
          title: intl.formatMessage(messages.errorToastMessage),
        })
      }

      modal.hideModal()
    }
  }

  const openActivateCardFormModal = async ({
    externalId,
    onCardActivated,
  }: {
    externalId: string
    onCardActivated: () => void
  }) => {
    await modal.showModal(ConfirmationModal, {
      open: true,
      icon: null,
      header: intl.formatMessage(messages.title),
      content: intl.formatMessage(messages.description),
      confirmButtonText: intl.formatMessage(messages.activateButton),
      handleDismiss: () => modal.hideModal(),
      onConfirm: (done) =>
        onActivateCardSubmit({ done, externalId, onCardActivated }),
    })
  }

  return {
    commands: {
      openActivateCardFormModal,
    },
  }
}
